import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ViewReasonComponent } from 'src/app/admin/components/view-reason/view-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let $: any;
@Component({
  selector: 'app-financial-page',
  templateUrl: './financial-page.component.html',
  styleUrls: ['./financial-page.component.css'],
})
/**
 * Component for managing the financial page in the admin section.
 *
 * Handles form initialization, data retrieval, file uploads, dynamic validation,
 * and saving of financial information for a user. Integrates with various services
 * for API communication, notifications, and UI updates. Supports dynamic form controls
 * and document management for multiple financial options.
 *
 * @remarks
 * - Uses reactive forms for dynamic validation and data binding.
 * - Handles file uploads and document management for multiple financial categories.
 * - Integrates with jQuery for certain UI manipulations.
 * - Provides step-based navigation and guideline display.
 */
export class FinancialPageComponent implements OnInit {
  settingsForm: FormGroup;
  private saveApi = environment.url + environment.financialSave;
  private getApi = environment.url + environment.financialGet;
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    this.settingsForm = this.fb.group({
      externalfundingCentre: [''],
      externalfundingdocuments: new FormArray([]),
      externalfundingImagefile: [''],
      externalfundingNooffunding: [''],
      externalfundingStatus: [''],
      accessToFundingIncCentre: [''],
      accessToFundingDocuments: new FormArray([]),
      accessToFundingImagefile: [''],
      accessToFundingStatus: [''],
      seedfundAvailedIncCentre: [''],
      seedFundAvailedDocuments: new FormArray([]),
      seedfundAvailedImagefile: [''],
      seedfundAvailedNoOfStartups: [''],
      seedfundAvailedStatus: [''],
      privateInvChannelsIncCentre: [''],
      privateInvChannelsUrlIcWebsite: [''],
      privateInvChannelsDocuments: new FormArray([]),
      privateInvChannelsImagefile: [''],
      privateInvChannelsStatus: [''],
      incentivesIncCentre: [''],
      incentivesDocuments: new FormArray([]),
      incentivesImagefile: [''],
      incentivesStudents: [''],
      incentivesUrlIcWebsite: [''],
      incentivesWomenStudents: [''],
      incentivesSocialCategory: [''],
      incentivesStatus: [''],
      revenueModelIncCentre: [''],
      revenueModelDocuments: new FormArray([]),
      revenueModelImagefile: [''],
      revenueModelNumbers: [''],
      revenueModelStatus: [''],
      // question-no-4
      programsschemesIncCentre: [''],
      programsSchemesDocuments: new FormArray([]),
      programsschemesUrlIcWebsite: [''],
      programsschemesNoofPrograms: [''],
      programsschemesImagefile: [''],
      programsschemesStatus: [0],
      // question-6
      formalmouCentre: [''],
      formalmoudocuments: new FormArray([]),
      formalmouImagefile: [''],
      formalmouNoofmou: [''],
      formalmouStatus: [''],
      // question7
      provisionofequityCentre: [''],
      provisionofequitydocuments: new FormArray([]),
      provisionofequityNoofstartups: [''],
      provisionofequityStatus: [''],
      provisionofequityImagefile: [''],
      provisionofequityUrlIcWebsite: [''],
      // question 10
      additionalprojectsCentre: [''],
      additionalprojectsdocuments: new FormArray([]),
      additionalprojectsImagefile: [''],
      additionalprojectsNoofprojects: [''],
      additionalprojectsStatus: [''],
    });
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  get setting() {
    return this.settingsForm.controls;
  }
  ngOnInit(): void {
    this.getPush();
    this.getDataApi();
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches financial data for the current user from the API and updates the form and UI accordingly.
   *
   * - Shows a loading indicator while fetching data.
   * - Retrieves user-specific financial data using the stored user ID.
   * - If the response is successful, patches the form with the received data.
   * - For each financial option marked as 'Yes' in the response, displays the corresponding UI options.
   * - Loads and displays associated documents for each financial option, updating the UI to reflect successful uploads.
   * - Handles UI updates using jQuery to show/hide upload and remove wrappers with success indicators.
   * - Hides the loading indicator after processing is complete.
   */
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        if (data.responseStatus != 'Failed') {
          this.settingsForm.patchValue(data);

          if (data.accessToFundingIncCentre == 'Yes') {
            this.showOptionsone('Yes', '.upload0', 0, '.set-succ0');
          }
          if (data.seedfundAvailedIncCentre == 'Yes') {
            this.showOptionstwo('Yes', '.upload1', 1, '.set-succ1');
          }
          if (data.privateInvChannelsIncCentre == 'Yes') {
            this.showOptionsthree('Yes', '.upload2', 2, '.set-succ2');
          }
          if (data.incentivesIncCentre == 'Yes') {
            this.showOptionsfour('Yes', '.upload3', 3, '.set-succ3');
          }
          if (data.revenueModelIncCentre == 'Yes') {
            this.showOptionsfive('Yes', '.upload4', 4, '.set-succ4');
          }
          // one
          if (data.externalfundingCentre == 'Yes') {
            this.showOptions6('Yes', '.upload5', 5, '.set-succ5');
          }
          if (data.programsschemesIncCentre == 'Yes') {
            this.showOptions7('Yes', '.upload6', 6, '.set-succ6');
          }
          // six
          if (data.formalmouCentre == 'Yes') {
            this.showOptions8('Yes', '.upload7', 7, '.set-succ7');
          }
          // 7
          if (data.provisionofequityCentre == 'Yes') {
            this.showOptions9('Yes', '.upload8', 8, '.set-succ8');
          }
          //10
          if (data.additionalprojectsCentre == 'Yes') {
            this.showOptions10('Yes', '.upload9', 9, '.set-succ9');
          }
          let getform = this.settingsForm.value;
          if (
            data.externalfundingdocuments != '' &&
            data.externalfundingdocuments != undefined
          ) {
            this.documentValues[5] = data.externalfundingdocuments;
            getform.externalfundingImagefile =
              data.externalfundingdocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ5').addClass('success');
              $('.upload-wrapper.upload5').addClass('d-none');
              $('.upload-wrapper.upload5').removeClass('success');
              $('.remove-wrapper.upload5').addClass('d-flex');
              $('.remove-wrapper.upload5').addClass('active');
            }, 5000);
          }
          if (
            data.accessToFundingDocuments != '' &&
            data.accessToFundingDocuments != undefined
          ) {
            this.documentValues[0] = data.accessToFundingDocuments;
            getform.accessToFundingImagefile =
              data.accessToFundingDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ0').addClass('success');
              $('.upload-wrapper.upload0').addClass('d-none');
              $('.upload-wrapper.upload0').removeClass('success');
              $('.remove-wrapper.upload0').addClass('d-flex');
              $('.remove-wrapper.upload0').addClass('active');
            }, 5000);
          }
          if (
            data.seedFundAvailedDocuments != '' &&
            data.seedFundAvailedDocuments != undefined
          ) {
            this.documentValues[1] = data.seedFundAvailedDocuments;
            getform.seedfundAvailedImagefile =
              data.seedFundAvailedDocuments[0].documentFile;

            setTimeout(function () {
              $('.set-succ1').addClass('success');
              $('.upload-wrapper.upload1').addClass('d-none');
              $('.upload-wrapper.upload1').removeClass('success');
              $('.remove-wrapper.upload1').addClass('d-flex');
              $('.remove-wrapper.upload1').addClass('active');
            }, 5000);
          }
          if (
            data.privateInvChannelsDocuments != '' &&
            data.privateInvChannelsDocuments != undefined
          ) {
            this.documentValues[2] = data.privateInvChannelsDocuments;
            getform.privateInvChannelsImagefile =
              data.privateInvChannelsDocuments[0].documentFile;

            setTimeout(function () {
              $('.set-succ2').addClass('success');
              $('.upload-wrapper.upload2').addClass('d-none');
              $('.upload-wrapper.upload2').removeClass('success');
              $('.remove-wrapper.upload2').addClass('d-flex');
              $('.remove-wrapper.upload2').addClass('active');
            }, 5000);
          }
          if (
            data.incentivesDocuments != '' &&
            data.incentivesDocuments != undefined
          ) {
            this.documentValues[3] = data.incentivesDocuments;
            getform.incentivesImagefile =
              data.incentivesDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ3').addClass('success');
              $('.upload-wrapper.upload3').addClass('d-none');
              $('.upload-wrapper.upload3').removeClass('success');
              $('.remove-wrapper.upload3').addClass('d-flex');
              $('.remove-wrapper.upload3').addClass('active');
            }, 5000);
          }
          if (
            data.revenueModelDocuments != '' &&
            data.revenueModelDocuments != undefined
          ) {
            this.documentValues[4] = data.revenueModelDocuments;
            getform.revenueModelImagefile =
              data.revenueModelDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ4').addClass('success');
              $('.upload-wrapper.upload4').addClass('d-none');
              $('.upload-wrapper.upload4').removeClass('success');
              $('.remove-wrapper.upload4').addClass('d-flex');
              $('.remove-wrapper.upload4').addClass('active');
            }, 5000);
          }
          if (
            data.programsSchemesDocuments != '' &&
            data.programsSchemesDocuments != undefined
          ) {
            this.documentValues[6] = data.programsSchemesDocuments;
            getform.programsschemesImagefile =
              data.programsSchemesDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ6').addClass('success');
              $('.upload-wrapper.upload6').addClass('d-none');
              $('.upload-wrapper.upload6').removeClass('success');
              $('.remove-wrapper.upload6').addClass('d-flex');
              $('.remove-wrapper.upload6').addClass('active');
            }, 5000);
          }
          if (
            data.formalmoudocuments != '' &&
            data.formalmoudocuments != undefined
          ) {
            this.documentValues[7] = data.formalmoudocuments;
            getform.formalmouImagefile =
              data.formalmoudocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ7').addClass('success');
              $('.upload-wrapper.upload7').addClass('d-none');
              $('.upload-wrapper.upload7').removeClass('success');
              $('.remove-wrapper.upload7').addClass('d-flex');
              $('.remove-wrapper.upload7').addClass('active');
            }, 5000);
          }
          if (
            data.provisionofequitydocuments != '' &&
            data.provisionofequitydocuments != undefined
          ) {
            this.documentValues[8] = data.provisionofequitydocuments;
            getform.provisionofequityImagefile =
              data.provisionofequitydocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ8').addClass('success');
              $('.upload-wrapper.upload8').addClass('d-none');
              $('.upload-wrapper.upload8').removeClass('success');
              $('.remove-wrapper.upload8').addClass('d-flex');
              $('.remove-wrapper.upload8').addClass('active');
            }, 5000);
          }
          if (
            data.additionalprojectsdocuments != '' &&
            data.additionalprojectsdocuments != undefined
          ) {
            this.documentValues[9] = data.additionalprojectsdocuments;
            getform.additionalprojectsImagefile =
              data.additionalprojectsdocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ9').addClass('success');
              $('.upload-wrapper.upload9').addClass('d-none');
              $('.upload-wrapper.upload9').removeClass('success');
              $('.remove-wrapper.upload9').addClass('d-flex');
              $('.remove-wrapper.upload9').addClass('active');
            }, 5000);
          }
          this.settingsForm.patchValue(getform);
          this.getdata.amizhthLoader('hide');
        }
      });
  }
  /**
   * Returns the color associated with the given value by delegating to the `questionStatus` method of `getdata`.
   *
   * @param val - The value for which the color is to be determined.
   * @returns The color corresponding to the provided value.
   */
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Opens a dialog to display the reason for the given status.
   * @param status - The status object or value to show the reason for.
   */
  viewReasonBtn(status) {
    const dialogRef = this.dialog.open(ViewReasonComponent, {
      width: '390px',
      data: { _status: status },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  setStatus(event, key, value) {
    this.settingsForm.controls[key].setValue(value);
  }
  /**
   * Populates the `documentValues` array with 11 new document request objects,
   * each containing empty `documentName` and `documentFile` fields.
   */
  getPush() {
    for (let i = 0; i < 11; i++) {
      let req = [
        {
          documentName: '',
          documentFile: '',
        },
      ];
      this.documentValues.push(req);
    }
  }
  selecetdFile: any = [];
  url: any;
  ImageValue: any = '';
  ImageType: any;
  documentValues = [];
  /**
   * Handles file upload events, processes selected files, updates form controls and UI states.
   * Accepts only jpeg, jpg, png, and pdf files.
   *
   * @param event - The file input change event.
   * @param val - A value used for UI selector construction.
   * @param i - Index indicating which document/form control to update.
   * @param set - Selector or reference for additional UI updates.
   */
  fileUpload(event, val, i, set) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          let splType = this.selecetdFile.type.split('/');
          this.url = reader.result;
          let spl = this.url.split(',');
          let val = this.documentValues[i];
          val[0].documentFile = spl[1];
          val[0].documentName = this.selecetdFile.name;
          this.documentValues[i] = val;

          if (i == 0) {
            this.settingsForm.controls['accessToFundingStatus'].setValue(7);
            this.settingsForm.controls['accessToFundingImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 1) {
            this.settingsForm.controls['seedfundAvailedStatus'].setValue(7);
            this.settingsForm.controls['seedfundAvailedImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 2) {
            this.settingsForm.controls['privateInvChannelsStatus'].setValue(7);
            this.settingsForm.controls['privateInvChannelsImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 3) {
            this.settingsForm.controls['incentivesStatus'].setValue(7);
            this.settingsForm.controls['incentivesImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 4) {
            this.settingsForm.controls['revenueModelStatus'].setValue(7);
            this.settingsForm.controls['revenueModelImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          // one
          if (i == 5) {
            this.settingsForm.controls['externalfundingStatus'].setValue(7);
            this.settingsForm.controls['externalfundingImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          //four
          if (i == 6) {
            this.settingsForm.controls['programsschemesStatus'].setValue(7);
            this.settingsForm.controls['programsschemesImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 7) {
            this.settingsForm.controls['formalmouStatus'].setValue(7);
            this.settingsForm.controls['formalmouImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 8) {
            this.settingsForm.controls['provisionofequityStatus'].setValue(7);
            this.settingsForm.controls['provisionofequityImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 9) {
            this.settingsForm.controls['additionalprojectsStatus'].setValue(7);
            this.settingsForm.controls['additionalprojectsImagefile'].setValue(
              this.selecetdFile.name
            );
          }
        };
        setTimeout(function () {
          let datass = '.upload-wrapper' + val;
          $(datass).addClass('uploaded');
        }, 600);
        setTimeout(function () {
          let datas = '.upload-wrapper' + val;
          $(datas).removeClass('uploaded');
          $(datas).addClass('success');
          $(set).addClass('success');
        }, 1600);
        setTimeout(function () {
          let datas = '.upload-wrapper' + val;
          $(datas).addClass('d-none');
          $(datas).removeClass('success');
          let data = '.remove-wrapper' + val;
          $(data).addClass('d-flex');
          $(data).addClass('active');
        }, 5000);
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png formet images are allowed'
        );
      }
    }
  }
  /**
   * Removes a file from the document values and resets the corresponding form control.
   * Also updates the UI by toggling CSS classes after a short delay.
   *
   * @param val - The value used to construct selector strings for UI manipulation.
   * @param i - The index of the document to remove.
   * @param set - The selector or reference for updating UI state.
   */
  removeFile(val, i, set) {
    this.documentValues[i][0].documentFile = '';
    this.documentValues[i][0].documentName = '';
    setTimeout(function () {
      let datass = '.upload-wrapper' + val;
      $(datass).removeClass('d-none');
      let data = '.remove-wrapper' + val;
      $(data).removeClass('d-flex');
      $(data).removeClass('active');
      $(set).removeClass('success');
    }, 1000);
    if (i == 0) {
      this.settingsForm.controls['accessToFundingImagefile'].setValue('');
    }
    if (i == 1) {
      this.settingsForm.controls['seedfundAvailedImagefile'].setValue('');
    }
    if (i == 2) {
      this.settingsForm.controls['privateInvChannelsImagefile'].setValue('');
    }
    if (i == 3) {
      this.settingsForm.controls['incentivesImagefile'].setValue('');
    }
    if (i == 4) {
      this.settingsForm.controls['revenueModelImagefile'].setValue('');
    }
    // one
    if (i == 5) {
      this.settingsForm.controls['externalfundingImagefile'].setValue('');
    }
    //four
    if (i == 6) {
      this.settingsForm.controls['programsschemesImagefile'].setValue('');
    }
    //six
    if (i == 7) {
      this.settingsForm.controls['formalmouImagefile'].setValue('');
    }
    // 7
    if (i == 8) {
      this.settingsForm.controls['provisionofequityImagefile'].setValue('');
    }
    if (i == 9) {
      this.settingsForm.controls['additionalprojectsImagefile'].setValue('');
    }
  }
  /**
   * Handles the logic for showing or hiding funding options based on user selection.
   * Updates form controls and validators accordingly.
   *
   * @param event - The user's selection value (e.g., 'Yes' or 'No').
   * @param val - The value associated with the file to be removed.
   * @param i - The index of the file in the list.
   * @param set - The set or collection the file belongs to.
   */
  Optionsonechecked;
  showOptionsone(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['accessToFundingStatus'].setValue(1);
      this.settingsForm.controls['accessToFundingImagefile'].setValue('');
      this.settingsForm.controls['accessToFundingImagefile'].clearValidators();
    } else {
      this.settingsForm.controls['accessToFundingImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'accessToFundingImagefile'
    ].updateValueAndValidity();
  }
  Optionstwochecked;
  showOptionstwo(event, val, i, set) {
    this.Optionstwochecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['seedfundAvailedStatus'].setValue(1);
      this.settingsForm.controls['seedfundAvailedNoOfStartups'].setValue(null);
      this.settingsForm.controls[
        'seedfundAvailedNoOfStartups'
      ].clearValidators();
      this.settingsForm.controls['seedfundAvailedImagefile'].setValue('');
      this.settingsForm.controls['seedfundAvailedImagefile'].clearValidators();
    } else {
      this.settingsForm.controls['seedfundAvailedNoOfStartups'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['seedfundAvailedImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'seedfundAvailedNoOfStartups'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'seedfundAvailedImagefile'
    ].updateValueAndValidity();
  }
  Optionsthreechecked;
  showOptionsthree(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['privateInvChannelsStatus'].setValue(1);
      this.settingsForm.controls['privateInvChannelsUrlIcWebsite'].setValue('');
      this.settingsForm.controls['privateInvChannelsImagefile'].setValue('');
      this.settingsForm.controls[
        'privateInvChannelsUrlIcWebsite'
      ].clearValidators();
      this.settingsForm.controls[
        'privateInvChannelsImagefile'
      ].clearValidators();
    } else {
      this.settingsForm.controls[
        'privateInvChannelsUrlIcWebsite'
      ].setValidators([Validators.required, RxwebValidators.url()]);
      this.settingsForm.controls['privateInvChannelsImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'privateInvChannelsUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'privateInvChannelsImagefile'
    ].updateValueAndValidity();
  }
  Optionsfourchecked;
  showOptionsfour(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['incentivesStatus'].setValue(1);
      this.settingsForm.controls['incentivesStudents'].setValue(null);
      this.settingsForm.controls['incentivesStudents'].clearValidators();
      this.settingsForm.controls['incentivesWomenStudents'].setValue(null);
      this.settingsForm.controls['incentivesWomenStudents'].clearValidators();
      this.settingsForm.controls['incentivesSocialCategory'].setValue(null);
      this.settingsForm.controls['incentivesSocialCategory'].clearValidators();
      this.settingsForm.controls['incentivesUrlIcWebsite'].setValue('');
      this.settingsForm.controls['incentivesUrlIcWebsite'].clearValidators();
      this.settingsForm.controls['incentivesImagefile'].setValue('');
      this.settingsForm.controls['incentivesImagefile'].clearValidators();
    } else {
      this.settingsForm.controls['incentivesStudents'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['incentivesWomenStudents'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['incentivesSocialCategory'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['incentivesUrlIcWebsite'].setValidators([
        Validators.required,
        RxwebValidators.url(),
      ]);
      this.settingsForm.controls['incentivesImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls['incentivesStudents'].updateValueAndValidity();
    this.settingsForm.controls['incentivesImagefile'].updateValueAndValidity();
    this.settingsForm.controls[
      'incentivesWomenStudents'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'incentivesSocialCategory'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'incentivesUrlIcWebsite'
    ].updateValueAndValidity();
  }
  Optionsfivechecked;
  showOptionsfive(event, val, i, set) {
    this.Optionsfivechecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['revenueModelStatus'].setValue(1);
      this.settingsForm.controls['revenueModelNumbers'].setValue(null);
      this.settingsForm.controls['revenueModelNumbers'].clearValidators();
      this.settingsForm.controls['revenueModelImagefile'].setValue('');
      this.settingsForm.controls['revenueModelImagefile'].clearValidators();
    } else {
      this.settingsForm.controls['revenueModelNumbers'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['revenueModelImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls['revenueModelNumbers'].updateValueAndValidity();
    this.settingsForm.controls[
      'revenueModelImagefile'
    ].updateValueAndValidity();
  }
  // one
  Options6checked;
  showOptions6(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['externalfundingStatus'].setValue(1);
      this.settingsForm.controls['externalfundingNooffunding'].setValue(null);
      this.settingsForm.controls[
        'externalfundingNooffunding'
      ].clearValidators();
      this.settingsForm.controls['externalfundingImagefile'].setValue('');
      this.settingsForm.controls['externalfundingImagefile'].clearValidators();
    } else {
      this.settingsForm.controls['externalfundingNooffunding'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['externalfundingImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'externalfundingNooffunding'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'externalfundingImagefile'
    ].updateValueAndValidity();
  }
  Options7checked;
  showOptions7(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['programsschemesStatus'].setValue(1);
      this.settingsForm.controls['programsschemesNoofPrograms'].setValue(null);
      this.settingsForm.controls[
        'programsschemesNoofPrograms'
      ].clearValidators();
      this.settingsForm.controls['programsschemesImagefile'].setValue('');
      this.settingsForm.controls['programsschemesImagefile'].clearValidators();
      this.settingsForm.controls['programsschemesUrlIcWebsite'].setValue('');
      this.settingsForm.controls[
        'programsschemesUrlIcWebsite'
      ].clearValidators();
    } else {
      this.settingsForm.controls['programsschemesNoofPrograms'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['programsschemesImagefile'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['programsschemesUrlIcWebsite'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'programsschemesNoofPrograms'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'programsschemesImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'programsschemesUrlIcWebsite'
    ].updateValueAndValidity();
  }
  Options8checked;
  showOptions8(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['formalmouNoofmou'].setValue(null);
      this.settingsForm.controls['formalmouNoofmou'].clearValidators();
      this.settingsForm.controls['formalmouStatus'].setValue(1);
      this.settingsForm.controls['formalmouImagefile'].setValue('');
      this.settingsForm.controls['formalmouImagefile'].clearValidators();
    } else {
      this.settingsForm.controls['formalmouNoofmou'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['formalmouImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls['formalmouNoofmou'].updateValueAndValidity();
    this.settingsForm.controls['formalmouImagefile'].updateValueAndValidity();
  }
  Options9checked;
  showOptions9(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['provisionofequityStatus'].setValue(1);
      this.settingsForm.controls['provisionofequityUrlIcWebsite'].setValue('');
      this.settingsForm.controls['provisionofequityImagefile'].setValue('');
      this.settingsForm.controls['provisionofequityNoofstartups'].setValue('');
      this.settingsForm.controls[
        'provisionofequityUrlIcWebsite'
      ].clearValidators();
      this.settingsForm.controls[
        'provisionofequityNoofstartups'
      ].clearValidators();
      this.settingsForm.controls[
        'provisionofequityImagefile'
      ].clearValidators();
    } else {
      this.settingsForm.controls['provisionofequityUrlIcWebsite'].setValidators(
        [Validators.required, RxwebValidators.url()]
      );
      this.settingsForm.controls['provisionofequityImagefile'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['provisionofequityNoofstartups'].setValidators(
        [Validators.required]
      );
    }
    this.settingsForm.controls[
      'provisionofequityUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'provisionofequityImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'provisionofequityNoofstartups'
    ].updateValueAndValidity();
  }
  Options10checked;
  showOptions10(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['additionalprojectsStatus'].setValue(1);
      this.settingsForm.controls['additionalprojectsNoofprojects'].setValue('');
      this.settingsForm.controls['additionalprojectsImagefile'].setValue('');
      this.settingsForm.controls[
        'additionalprojectsNoofprojects'
      ].clearValidators();
      this.settingsForm.controls[
        'additionalprojectsImagefile'
      ].clearValidators();
    } else {
      this.settingsForm.controls[
        'additionalprojectsNoofprojects'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['additionalprojectsImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'additionalprojectsNoofprojects'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'additionalprojectsImagefile'
    ].updateValueAndValidity();
  }

  /**
   * Handles the save button click event.
   * Validates the form, attaches document values if present, and submits the data to the API.
   * Shows notifications based on the result.
   */
  saveBtn() {
    let getform = this.settingsForm.value;

    if (this.settingsForm.invalid) {
      this.settingsForm.markAllAsTouched();
      this.notify.notifyError('Form is Invalid !!');
    } else {
      if (this.documentValues[0][0].documentFile != '') {
        getform.accessToFundingDocuments = this.documentValues[0];
      }
      if (this.documentValues[1][0].documentFile != '') {
        getform.seedFundAvailedDocuments = this.documentValues[1];
      }
      if (this.documentValues[2][0].documentFile != '') {
        getform.privateInvChannelsDocuments = this.documentValues[2];
      }
      if (this.documentValues[3][0].documentFile != '') {
        getform.incentivesDocuments = this.documentValues[3];
      }
      if (this.documentValues[4][0].documentFile != '') {
        getform.revenueModelDocuments = this.documentValues[4];
      }
      // one
      if (this.documentValues[5][0].documentFile != '') {
        getform.externalfundingdocuments = this.documentValues[5];
      }
      //four
      if (this.documentValues[6][0].documentFile != '') {
        getform.programsSchemesDocuments = this.documentValues[6];
      }
      // six
      if (this.documentValues[7][0].documentFile != '') {
        getform.formalmoudocuments = this.documentValues[7];
      }
      // 7
      if (this.documentValues[8][0].documentFile != '') {
        getform.provisionofequitydocuments = this.documentValues[8];
      }
      if (this.documentValues[9][0].documentFile != '') {
        getform.additionalprojectsdocuments = this.documentValues[9];
      }

      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.step++;
          this.notify.notifysuccess(data.responseMessage);
          this.getDataApi();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      this.guidelineValue = data[2].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.saveBtn();
  }
  prevStep() {
    this.step--;
  }
}
